module.exports = __webpack_public_path__ + "static/witch_4k-c284625546d3025fbca4d840801e7f38.jpg";